export function reloadTrip(store,{func,params,seconds=1110}) {
    return setInterval(() => {store.dispatch(func,params)}, seconds*1000);    
}

export function reloadModel(store,{func,seconds=10,params,silence,model}) {
    return setInterval(() => {store.dispatch(func,{params,model,silence})}, seconds*1000);    
}